var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToiletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.625003V0.5H5.66406V8.94397H15C14.9946 9.67191 14.8622 10.3553 14.5485 10.9969C14.0659 11.9849 13.2946 12.6782 12.3298 13.1691C12.2352 13.2174 12.1962 13.2699 12.197 13.3812C12.2028 14.0579 12.1999 14.735 12.1999 15.4116V15.5646H14.0672V16.5H3.79679V15.5587H5.63792C5.65244 15.5433 5.65866 15.5396 5.65866 15.5358C5.66074 14.7966 5.66364 14.0574 5.65991 13.3183C5.65991 13.277 5.61053 13.2228 5.56986 13.197C5.31177 13.0337 5.03624 12.8949 4.791 12.7141C3.75986 11.9532 3.10548 10.9519 2.91958 9.66566C2.88514 9.42607 2.87062 9.18356 2.84531 8.93022H1.05356C1.04401 8.86689 1.03488 8.81605 1.02824 8.7648C0.889236 7.64435 0.751473 6.52391 0.61205 5.40388C0.448975 4.09259 0.286315 2.78131 0.121165 1.47044C0.0858945 1.18835 0.040665 0.907094 0 0.625003ZM2.86647 4.23718H3.78641V2.38713H2.86647V4.23718Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.08453C15.9896 7.09981 15.9776 7.11509 15.9688 7.1306C15.8437 7.35961 15.5118 7.49892 15.0775 7.49936C14.0679 7.50047 13.0587 7.4998 12.0491 7.4998C10.4349 7.4998 8.82066 7.4998 7.20646 7.4998H7.00334C7.00334 7.42915 7.00294 7.36138 7.00334 7.2936C7.00454 7.17733 6.99094 7.06039 7.01133 6.945C7.05532 6.6945 7.43718 6.50624 7.89621 6.50381C8.42081 6.50093 8.94582 6.50314 9.47042 6.50314C11.2798 6.50314 13.0887 6.50779 14.898 6.50004C15.3998 6.49783 15.8245 6.58133 16 6.91842V7.08453Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToiletIcon);
export default __webpack_public_path__ + "static/media/toiletIcon.b43f4b2f01e752f35f0bc2c633986e1b.svg";
export { ForwardRef as ReactComponent };